const css = `.support-page {
  container-type: inline-size;
}
.support-page h1 {
  font-size: var(--font-size-5xl);
  font-weight: var(--font-weight-semibold);
  margin-bottom: 16px;
  color: var(--text);
}
.support-page .subtitle {
  font-size: var(--font-size-base);
  color: var(--text-muted);
  margin-top: 16px;
  margin-bottom: 16px;
  line-height: var(--line-height-normal);
}
.support-page .support-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.support-page .support-content .form-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.support-page .support-content .form-section .form-card,
.support-page .support-content .form-section .faq-card,
.support-page .support-content .form-section .tickets-info-card {
  box-shadow: var(--shadow-4);
  border-radius: 12px;
  overflow: hidden;
}
.support-page .support-content .form-section .tickets-info-card .tickets-info-text {
  color: var(--text-muted);
  margin: 16px 0 0 0;
  line-height: var(--line-height-normal);
  font-size: var(--font-size-base);
}
.support-page .support-content .form-section .tickets-info-card .p-divider {
  margin: 16px 0;
}
.support-page .support-content .form-section .tickets-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}
.support-page .support-content .form-section .tickets-actions .new-ticket-button {
  align-self: flex-end;
}
.support-page .support-content .form-section .card-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.support-page .support-content .form-section .card-header .card-icon {
  font-size: var(--font-size-xl);
  color: var(--text);
  margin-right: 16px;
}
.support-page .support-content .form-section form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.support-page .support-content .form-section form .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
.support-page .support-content .form-section form .services-section label {
  display: block;
  margin-bottom: 12px;
  font-weight: var(--font-weight-medium);
  color: var(--text);
}
.support-page .support-content .form-section form .services-section .services-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
.support-page .support-content .form-section form .services-section .services-grid .service-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.support-page .support-content .form-section form .services-section .services-grid .service-item label {
  margin: 0;
  cursor: pointer;
}
.support-page .support-content .contact-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.support-page .support-content .contact-section .contact-method {
  box-shadow: var(--shadow-4);
  border-radius: 12px;
  overflow: hidden;
}
.support-page .support-content .contact-section .contact-method .card-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.support-page .support-content .contact-section .contact-method .card-header .card-icon {
  font-size: var(--font-size-xl);
  color: var(--text);
  margin-right: 16px;
}
.support-page .support-content .contact-section .contact-method p {
  color: var(--text-muted);
  margin: 16px 0;
  line-height: var(--line-height-normal);
}
.support-page .support-content .contact-section .contact-method .p-divider {
  margin: 16px 0;
}
.support-page .support-content .contact-section .contact-method .contact-button {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 8px;
  padding: 12px;
  border-radius: 8px;
}
.support-page .support-content .contact-section .contact-method .contact-button .p-button-label {
  text-align: left;
}
.support-page .support-content .contact-section .contact-method .contact-button:last-child {
  margin-bottom: 0;
}
.support-page .support-content .contact-section .contact-method .contact-button .p-button-icon {
  margin-right: 12px;
  font-size: var(--font-size-lg);
}
.support-page .support-content .contact-section .contact-method .contact-button:hover {
  background-color: var(--surface-100);
}
@container (max-width: 768px) {
  .support-page .support-content .form-section form .form-row {
    grid-template-columns: 1fr;
  }
  .support-page .support-content .form-section form .services-section .services-grid {
    grid-template-columns: 1fr;
  }
  .support-page .support-content .form-section form .p-inputtext,
  .support-page .support-content .form-section form .p-inputtextarea {
    width: 100%;
  }
  .support-page .support-content .form-section form .send-message-button {
    width: 100%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
